export var DIALOG_TYPES;
(function(DIALOG_TYPES) {
    DIALOG_TYPES["confirm"] = "confirm";
    DIALOG_TYPES["form"] = "form";
})(DIALOG_TYPES || (DIALOG_TYPES = {}));
export var BUTTON_TYPES;
(function(BUTTON_TYPES) {
    BUTTON_TYPES["alert"] = "alert";
    BUTTON_TYPES["primary"] = "primary";
    BUTTON_TYPES["success"] = "success";
})(BUTTON_TYPES || (BUTTON_TYPES = {}));

//# sourceMappingURL=dialogs.js.map